import { useSessionStore } from "Common/Stores";
import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface AuthProtectedProps {
  children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  //TODO: Add your authentication logic here

  const { session, isAuthtenticated } = useSessionStore();

  if (!session?.token || !isAuthtenticated) {
    return <Navigate to={{ pathname: "/login" }} />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProtected;
